import Vue from 'vue';
import axios from 'axios';
import store from "./vuex/store";
import VueAxios from 'vue-axios';
import Mixin from "./mixins/GlobalMixins";
import linkify from 'vue-linkify'
Vue.directive('linkified', linkify);
import App from './components/App.vue';
import jQuery from 'jquery';

axios.defaults.baseURL = window.chaton_scripts_vars.restapiurl;
axios.defaults.headers.common['Authorization'] = `Bearer ` + window.chaton_scripts_vars.authToken;
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.use(VueAxios, axios);
Vue.config.productionTip = true;
Vue.mixin(Mixin); 

// Filters
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

var chatEnable = window.chaton_scripts_vars.chatSetting.chatonSupportEnable
if( jQuery('#chaton-widget-chat').length) {
  new Vue({
    store,
    render: h => {
      if(chatEnable){
        return h(App)
      }
      return ''
    },
  }).$mount('#chaton-widget-chat')
}
